
import { defineComponent } from "vue";
import { mapGetters } from "vuex";

export default defineComponent({
  name: "iban-swift-payment-account",
  props: {
    isAtOwnProfile: {
      type: Boolean,
      default: () => false
    }
  },
  computed: {
    ...mapGetters("UsersModule", ["getSingleUser"])
  }
});
